import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Model, { onChange as onChangeModel } from '../../../lib/Model'
import { Form, Field, Input, Select, Button, Note, H2, Copyright } from '../../Common'
import { isValidEmail } from '../../../lib/validators'

import style from './Step.scss'

class Step2 extends Component {
  static propTypes = {
    onPreviousStep: PropTypes.func.isRequired,
    onNextStep: PropTypes.func.isRequired,
    isFromFacebook: PropTypes.bool,
    form: PropTypes.shape({
      name: PropTypes.string,
      company_email: PropTypes.string,
      phone: PropTypes.string,
      company: PropTypes.string,
      company_size: PropTypes.string,
      company_area: PropTypes.string,
      position: PropTypes.string,
      similar_tool: PropTypes.string,
    }),
  }

  state = {
    form: {
      submitted: false,
      name: new Model('name'),
      company_email: new Model('company_email'),
      phone: new Model('phone', '', 'tel'),
      company: new Model('company'),
      company_size: new Model('company_size', '', 'select', {
        options: [
          '1 a 10 colaboradores',
          '10 a 25 colaboradores',
          '26 a 100 colaboradores',
          '101 a 200 colaboradores',
          'Acima de 200 colaboradores',
        ],
      }),
      company_area: new Model('company_area', '', 'select', {
        options: [
          'Agência Digital',
          'Agência de Publicidade e Marketing',
          'Assessoria de Imprensa',
          'Call Center',
          'Consultoria e Treinamento',
          'E-commerce',
          'Educação e Ensino',
          'Engenharia e Indústria Geral',
          'Eventos',
          'Financeiro, Jurídico e Serviços Relacionados',
          'Governo e Órgãos Públicos',
          'Hardware e Eletrônicos',
          'Imobiliárias',
          'ONGs',
          'Saúde e Estética',
          'Serviços em Geral',
          'Serviços em RH e Coaching',
          'Software e Cloud',
          'Telecomunicações',
          'Turismo e Lazer',
          'Varejo',
        ],
      }),
      position: new Model('position', '', 'select', {
        options: [
          'Analista',
          'Assistente',
          'Comprador(a)',
          'Coordenador(a)',
          'Diretor(a)',
          'Estudante',
          'Freelancer',
          'Gerente',
          'Operador(a)',
          'Recepcionista',
          'Supervisor(a)',
          'Outros',
        ],
      }),
      similar_tool: new Model('similar_tool'),
    },
  }

  UNSAFE_componentWillMount() {
    let nextState = { ...this.state }

    for (let field in this.props.form) {
      let _field = this.props.form[field]

      // nao percorre chaves herdadas
      // atualiza o nextState com o que veio de props
      if (this.props.form.hasOwnProperty(field)) {
        if (_field) {
          nextState.form[field].value = _field
        }
      }
    }

    this.setState(nextState)
  }

  handleChange = (event, model) => {
    if (model.name === 'company_email' && model.value) {
      model.error.validEmail = isValidEmail(model.value)
    }
    this.setState(onChangeModel(model))
  }

  handleSubmit = () => {
    const stateForm = this.state.form

    if (stateForm.submitted === false) {
      this.setState((state) => ({
        ...state,
        form: {
          ...state.form,
          submitted: true,
        },
      }))
    }

    for (let field in stateForm) {
      let _field = stateForm[field]

      // nao percorre chaves herdadas
      if (stateForm.hasOwnProperty(field) && _field && _field.invalid === true) {
        return
      }
    }

    // apenas key => value
    let submitObj = {}
    for (let field in stateForm) {
      submitObj[field] = stateForm[field].value
    }

    this.props.onNextStep(submitObj, 'ok')
  }

  render() {
    const { onPreviousStep } = this.props
    const stateForm = this.state.form

    let arrFieldsInvalid = []
    let hasInvalidField = false
    let isInvalid
    let _field

    for (let field in stateForm) {
      _field = stateForm[field]
      isInvalid = stateForm.submitted && _field.untouched && _field.invalid

      if (isInvalid && !hasInvalidField) {
        hasInvalidField = true
      }

      if (stateForm.hasOwnProperty(field)) {
        arrFieldsInvalid[field] = isInvalid
      }
    }

    let corporativeEmailField = this.props.isFromFacebook ? (
      // let corporativeEmailField = true ? (
      <Field label="e-mail corporativo" className={style.field}>
        <Input
          id="id-email-corporativo"
          model={stateForm.company_email}
          name={stateForm.company_email.name}
          type={stateForm.company_email.type}
          onChange={this.handleChange}
          invalid={arrFieldsInvalid['company_email']}
          required
          size="xl"
        />
        <Note id="erro-email-corporativo-obrigatorio" error show={arrFieldsInvalid['company_email']}>
          campo obrigatório
        </Note>
        <Note id="erro-email-invalido" error show={stateForm.company_email.error.validEmail === false}>
          e-mail inválido
        </Note>
      </Field>
    ) : null

    return (
      <div className={style.step}>
        <H2 className={style.title}>mais algumas informações</H2>

        <Form id="form-step2" onSubmit={this.handleSubmit} className={style.form}>
          <Field label="nome completo" className={style.field}>
            <Input
              id="input-nome-completo"
              model={stateForm.name}
              name={stateForm.name.name}
              type={stateForm.name.type}
              onChange={this.handleChange}
              autoFocus
              invalid={arrFieldsInvalid['name']}
              required
              size="xl"
            />
            <Note id="erro-nome-obrigatorio" error show={arrFieldsInvalid['name']}>
              campo obrigatório
            </Note>
          </Field>

          {corporativeEmailField}

          <Field label="telefone com ddd" className={style.field}>
            <Input
              id="telefone-com-ddd"
              model={stateForm.phone}
              name={stateForm.phone.name}
              type={stateForm.phone.type}
              onChange={this.handleChange}
              invalid={arrFieldsInvalid['phone']}
              required
              mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              size="xl"
            />
            <Note id="erro-telefone-invalido" error show={arrFieldsInvalid['phone']}>
              informação inválida ou não preenchida
            </Note>
          </Field>

          <Field label="empresa" className={style.field}>
            <Input
              id="empresa"
              model={stateForm.company}
              name={stateForm.company.name}
              type={stateForm.company.type}
              onChange={this.handleChange}
              invalid={arrFieldsInvalid['company']}
              required
              size="xl"
            />
            <Note id="empresa-obrigatorio" error show={arrFieldsInvalid['company']}>
              campo obrigatório
            </Note>
          </Field>

          <Field label="quantos colaboradores possui a sua empresa?" className={style.field}>
            <Select
              id="select-qtd-empresa"
              model={stateForm.company_size}
              name={stateForm.company_size.name}
              type={stateForm.company_size.type}
              onChange={this.handleChange}
              invalid={arrFieldsInvalid['company_size']}
              required
            />
            <Note id="erro-qtd-empresa-obrigatorio" error show={arrFieldsInvalid['company_size']}>
              campo obrigatório
            </Note>
          </Field>

          <Field label="qual a área de atuação da sua empresa?" className={style.field}>
            <Select
              id="area-atuacao"
              model={stateForm.company_area}
              name={stateForm.company_area.name}
              type={stateForm.company_area.type}
              onChange={this.handleChange}
              invalid={arrFieldsInvalid['company_area']}
              required
            />
            <Note id="erro-area-atuacao" error show={arrFieldsInvalid['company_area']}>
              campo obrigatório
            </Note>
          </Field>

          <Field label="qual o seu cargo?" className={style.field}>
            <Select
              id="select-cargo"
              model={stateForm.position}
              name={stateForm.position.name}
              type={stateForm.position.type}
              onChange={this.handleChange}
              invalid={arrFieldsInvalid['position']}
              required
            />
            <Note id="erro-select-cargo" error show={arrFieldsInvalid['position']}>
              campo obrigatório
            </Note>
          </Field>

          <Field label="já usa uma ferramenta semelhante? Se sim, qual?" className={style.field}>
            <Input
              id="ferrameta-semelhante"
              model={stateForm.similar_tool}
              name={stateForm.similar_tool.name}
              type={stateForm.similar_tool.type}
              onChange={this.handleChange}
              size="xl"
            />
          </Field>

          <Button id="proximo" submit xl>
            próximo
          </Button>

          <Note id="erro-verifique-campos" error show={hasInvalidField}>
            revise os campos do formulário e tente novamente
          </Note>

          <Note>passo 2 de 2</Note>
        </Form>

        <a id="link-voltar" onClick={() => onPreviousStep(1)} className={style.back}>
          voltar
        </a>

        <Copyright className={style.copyright} />
      </div>
    )
  }
}

export default Step2



// WEBPACK FOOTER //
// ./src/components/Signup/Steps/Step2.js